// Copyright (c) 2017-2022 Uber Technologies Inc.
//
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { getQueryStringFromObject } from '@/helpers';
import api from '@/api';

const URL_BASE = 'https://cadenceweb-paas.apps.digiwincloud.com.cn/api/feature-flags/';

class FeatureFlagService {
  // eslint-disable-next-line class-methods-use-this
  async isFeatureFlagEnabled({ name = '', params = {} }) {
    const queryParams = getQueryStringFromObject(params);
    const url = [URL_BASE, name, queryParams].join('');
    const res = await api.getIsFeatureFlagEnabled(url);

    // const res = httpService.get(url);
    return res

    // return  res.value;
  }

  getConfiguration(args) {
    return this.isFeatureFlagEnabled(args);
  }
}

const featureFlagService = new FeatureFlagService();

export default featureFlagService;
